<script>
  import { getContext } from "svelte";
  import { countryStore } from "../store/Countries.js";
  import { link, navigate } from "svelte-routing";

  const { close } = getContext("modal");
  const { snackbar } = getContext("app");
  function closeModal() {
    close();
  }

  export let countryVersion = {
    mainVersion: null,
    subVersion: null,
    countryId: null,
  };
  async function save() {
    if (
      countryVersion.mainVersion == null ||
      countryVersion.subVersion == null
    ) {
      snackbar("info", "Fill in a version");
      return;
    }
    var result = await countryStore.saveCountryVersion(countryVersion);
    if (result.success) {
      snackbar("info", "Country version saved");
      navigate("/app/countryversion/" + result.data);
      close();
    } else {
      snackbar("error", result.message);
    }
  }

  function init(element) {
    element.focus();
  }
</script>

<div class="modal-header">
  <h5 class="modal-title" id="exampleModalLabel">
    Add country version for {$countryStore.currentCountry &&
      $countryStore.currentCountry.country.nameKey}
  </h5>
</div>
<div class="modal-body">
  <label for="mainversion">Main Version</label>
  <input
    type="number"
    class="form-control"
    placeholder="main version number "
    bind:value={countryVersion.mainVersion}
    use:init
    required=""
    id="mainversion"
  />
  <label for="subversion">Sub Version</label>
  <input
    type="number"
    class="form-control"
    placeholder="sub version number "
    bind:value={countryVersion.subVersion}
    required=""
    id="subversion"
  />
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" on:click={closeModal}>
    Close
  </button>
  <button type="button" class="btn btn-primary" on:click={save}>Save</button>
</div>
